import { ENTITY_VALUES } from "../config/constants";

export const entitiesPageValidator = (entity = {}, extraData, isNcaa) => {
  const entityType = !entity ? ENTITY_VALUES.PLAYER : !entity.type ? ENTITY_VALUES.PLAYER : entity.type;
  // Multiusage entity values at top
  const { name, namespaced_id } = entity;
  const {
    teamId,
    firstName,
    lastName,
    position,
    status,
    jerseyNumber
  } = extraData || {};
  let personValidate = !firstName || !lastName || !position ||  jerseyNumber === '' ||  jerseyNumber == null;
  if(!isNcaa) personValidate = personValidate ;
  switch (entityType) {
    case ENTITY_VALUES.PLAYER:
      if(!teamId){
        return !entity.group || personValidate || !status;
      }else{
        return !teamId || personValidate || !status;
      }
    case ENTITY_VALUES.BALL:
      return !name || !namespaced_id;
    case ENTITY_VALUES.OFFICIAL:
      return !name || personValidate;
    case ENTITY_VALUES.OBJECT:
      return !name;
    default:
      return false;
  }
};

/**
 * Validator to check if the new time value is correct
 * @param {timestamp} newTime The new time to be evaluated
 * @param {number} index Period's current index
 * @param {string} caller Key value for current practice drills to check if it's startTime or endTime
 * @param {Object} currentPractice current practice with full data
 */
export const periodsTableTimeValidator = (key, index, currentPractice) => {
  const now = (new Date()).getTime();
  const newTime = currentPractice.drills[index][key];
  if (!newTime) {
    return '';
  }

  if (key === 'startTs') {
    // when start time is changed, I must check that it is greater or equal than the previous period's endTs
    // it also has to be less or equal than end time if it exists
    if (index > 0 && currentPractice.drills[index - 1].endTs > newTime) {
      return `Period start time cannot be lower than the previous period end time.`;
    }
    if (currentPractice.drills[index].endTs && currentPractice.drills[index].endTs < newTime) {
      return 'Period start time cannot be greater than the current end time.';
    }
    if (currentPractice.drills[index].startTs > now) {
      return 'Period start time cannot be greater than the current time.';
    }
  } else {
    // when end time is changed, it must be less or equal to the next start time (if it exists)
    // it has to be greater or equal to current index's startTs
    if (index < currentPractice.drills.length - 1 && currentPractice.drills[index + 1].startTs && currentPractice.drills[index + 1].startTs < newTime) {
      return `Period end time cannot be greater than the next period start time.`;
    }
    if (currentPractice.drills[index].startTs > newTime) {
      return 'Period end time cannot be lower than the current start time.';
    }
    if (currentPractice.drills[index].endTs > now){
      return 'Period end time cannot be greater than the current time.';
    }
  }

  return '';
};

export const eventsTableTimeValidator = (key, index, currentPractice) => {
  const now = (new Date()).getTime();
  const newTime = currentPractice.combineEvents[index][key];
  if (!newTime) {
    return '';
  }
  if (key === 'stTime') {
    // when start time is changed, I must check that it is greater or equal than the previous period's endTs
    // it also has to be less or equal than end time if it exists
    if (currentPractice.combineEvents[index].endTime && currentPractice.combineEvents[index].endTime < newTime) {
      return 'Event start time cannot be greater than the current end time.';
    }
    if (currentPractice.combineEvents[index].stTime > now) {
      return 'Event start time cannot be greater than the current time.';
    }
  } else {
    if (currentPractice.combineEvents[index].stTime > newTime) {
      return 'Event end time cannot be lower than the current start time.';
    }
    if (currentPractice.combineEvents[index].endTime > now){
      return 'Event end time cannot be greater than the current time.';
    }
  }

  return '';
};
